/* import __COLOCATED_TEMPLATE__ from './multi-participant.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import type Fin from 'embercom/models/operator/visual-builder/step/fin';

interface Signature {
  Args: {
    accordion: $TSFixMe;
    step: Fin;
    isReadOnly: boolean;
  };
}

export default class MultiParticipant extends Component<Signature> {
  get silentWhenCcRecipient(): boolean {
    return this.args.step?.finSilentWhenCcRecipient ?? false;
  }

  // Settable so the RadioGroup's two-way @selected write lands on the step attr
  // instead of throwing on a getter-only property.
  set silentWhenCcRecipient(value: boolean) {
    this.args.step.finSilentWhenCcRecipient = value;
  }

  get replyToSenderOnly(): boolean {
    return this.args.step?.finReplyToSenderOnly ?? false;
  }

  set replyToSenderOnly(value: boolean) {
    this.args.step.finReplyToSenderOnly = value;
  }

  get participationOptions() {
    return [
      {
        value: false as const,
        translationKey:
          'operator.workflows.visual-builder.pass-to-fin.settings.multi-participant.participation.option-reply-all',
      },
      {
        value: true as const,
        translationKey:
          'operator.workflows.visual-builder.pass-to-fin.settings.multi-participant.participation.option-not-respond-when-cc',
      },
    ];
  }

  get replyScopeOptions() {
    return [
      {
        value: false as const,
        translationKey:
          'operator.workflows.visual-builder.pass-to-fin.settings.multi-participant.reply-scope.option-reply-all',
      },
      {
        value: true as const,
        translationKey:
          'operator.workflows.visual-builder.pass-to-fin.settings.multi-participant.reply-scope.option-reply-to-sender-only',
      },
    ];
  }

  @action
  setSilentWhenCcRecipient(value: boolean) {
    this.args.step.finSilentWhenCcRecipient = value;
  }

  @action
  setReplyToSenderOnly(value: boolean) {
    this.args.step.finReplyToSenderOnly = value;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::Sections::MultiParticipant': typeof MultiParticipant;
    'workflows/graph-editor/node-items/steps/fin/sections/multi-participant': typeof MultiParticipant;
  }
}
